import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import store from '../store'
import { LoginStatus, ViewRequirements, RouteNames, Areas } from '@/utils/constants/navigationConstants'

Vue.use(VueRouter)

const routes = [
  CreateRoute('/login', 'Login', Login, ViewRequirements.NotLogged),
  CreateRoute('/forgot-password', 'ForgotPassword', () => import('../views/ForgotPassword'), ViewRequirements.NotLogged),
  CreateRoute('/forgot-username', 'ForgotUsername', () => import('../views/ForgotUsername'), ViewRequirements.NotLogged),
  CreateRoute('/create-user', 'CreateUser', () => import('../views/CreateUser'), ViewRequirements.NotLogged),
  CreateRoute('/change-password', 'ChangePassword', () => import('../views/UserActivation/ChangePassword'), ViewRequirements.ChangePasswordRequired),
  CreateRoute('/security-questions', 'SecurityQuestions', () => import('../views/UserActivation/SecurityQuestions'), ViewRequirements.NoSecurityQuestions),
  CreateRoute('/terms-of-use', 'TermsOfUse', () => import('../views/UserActivation/TermsOfUse'), ViewRequirements.TermsOfUseNotAccepted),
  CreateRoute('/location-search', 'LocationSearch', () => import('../views/LocationSearch'), ViewRequirements.LocationNotAccessed, Areas.Accounts),
  CreateRoute('/settings', 'Settings', () => import('../views/Settings/Settings'), ViewRequirements.Logged, Areas.Settings),
  CreateRoute('/my-profile', 'MyProfile', () => import('../views/Settings/MyProfile'), ViewRequirements.Logged, Areas.Settings),
  CreateRoute('/my-profile/change-password', 'MyProfile_ChangePassword', () => import('../views/Settings/ChangePassword'), ViewRequirements.Logged, Areas.Settings),
  CreateRoute('/not-found', RouteNames.NotFound, () => import('../views/Errors/NotFound404'), ViewRequirements.Logged),
  CreateRoute('/forbidden', RouteNames.Forbidden, () => import('../views/Errors/Forbidden403'), ViewRequirements.Logged),
  CreateRoute('/location', 'Location', () => import('../views/SystemTest/Location'), ViewRequirements.LocationAccessed, Areas.Accounts),
  CreateRoute('/place-on-test', 'PlaceOnTest', () => import('../views/SystemTest/PlaceOnTest'), ViewRequirements.LocationAccessed, Areas.Accounts),
  CreateRoute('/extend-test', 'ExtendTest', () => import('../views/SystemTest/ExtendTest'), ViewRequirements.LocationAccessed, Areas.Accounts),
  CreateRoute('/test-history', 'TestHistory', () => import('../views/TestHistory/TestHistory'), ViewRequirements.LocationAccessed, Areas.Accounts),
  CreateRoute('/test-history-details/:testKey', 'TestHistoryDetails', () => import('../views/TestHistory/TestHistoryDetails'), ViewRequirements.LocationAccessed, Areas.Accounts),
  CreateRoute('/activity-details/:testKey/:seqNo', 'ActivityDetails', () => import('../views/TestHistory/ActivityDetails'), ViewRequirements.LocationAccessed, Areas.Accounts),
  CreateRoute('/last-alarm-signals', 'LastAlarmSignals', ()=>import('../views/LastAlarmSignals/LastAlarmSignals.vue'), ViewRequirements.LocationAccessed, Areas.Accounts),
  CreateRoute('/alarm-details/:seqNo/:eventDate/:systemId', 'AlarmDetails', ()=>import('../views/LastAlarmSignals/AlarmDetails.vue'), ViewRequirements.LocationAccessed, Areas.Accounts),
  {
    path: '/',
    redirect: () => {
      switch (store.getters.loginStatus) {
        case LoginStatus.NotLogged: return '/login';
        case LoginStatus.ChangePasswordRequired: return '/change-password';
        case LoginStatus.NoSecurityQuestions: return '/security-questions';
        case LoginStatus.TermsOfUseNotAccepted: return '/terms-of-use';
        case LoginStatus.LocationNotAccessed: return '/location-search';
        case LoginStatus.LocationAccessed: return '/location';
      }
    }
  },
  {
    path: "/accounts",
    redirect: () => {
      switch (store.getters.loginStatus) {
        case LoginStatus.LocationNotAccessed: return '/location-search';
        case LoginStatus.LocationAccessed: return '/location';
      }
    }
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  let requirements = to.meta.requirements;
  let loginStatus = store.getters.loginStatus;

  store.commit('clearAllNoties');

  if (requirements.includes(loginStatus)) { 
    store.commit("requestStarts", 'navigation');
    next();
  } else {
    next({
      path: '/'
    });
  }

})

router.afterEach(() => {
  store.commit("requestEnds", 'navigation');
})

function CreateRoute(path, name, component, requirements, area) {
  let meta = { requirements: requirements };
  if (area) {
    meta["area"] = area;
  }

  return {
    path: path,
    name: name,
    component: component,
    meta: meta
  }
}


export default router
